import React, { createContext, useContext, useMemo } from "react"
import { createContextualCan } from "@casl/react"
import { AppAbility, defineAbility } from "../../auth/ability"
import { TPermission } from "../../auth/permissions"
import { useAuth } from "./AuthContext"

export const AbilityContext = createContext<AppAbility>(defineAbility([]))

export const Can = createContextualCan(AbilityContext.Consumer)

export const useAbility = () => useContext(AbilityContext)

export const AbilityProvider = ({ permissions, children }: { permissions: TPermission[]; children: React.ReactNode }) => {
    const ability = useMemo(() => defineAbility(permissions), [permissions])
    return <AbilityContext.Provider value={ability}>{children}</AbilityContext.Provider>
}

const NO_PERMISSIONS: TPermission[] = []

/** Rechte aus der aktuellen Portal-Session (/portal/auth/session bzw. Login-Antwort). */
export const SessionAbilityProvider = ({ children }: { children: React.ReactNode }) => {
    const { session } = useAuth()
    return <AbilityProvider permissions={session?.permissions ?? NO_PERMISSIONS}>{children}</AbilityProvider>
}
